import types from './types';

export default {
  [types.SET_USER](state, user) {
    state.user = user;
  },

  [types.SET_PROFILE](state, profile) {
    state.profile = profile;
  },

  [types.SET_MENU](state, userMenu) {
    state.userMenu = userMenu;
  },

  [types.SET_PERMISSIONS](state, permissions) {
    state.permissions = permissions;
  },

  [types.SET_COMPANIES](state, companies) {
    state.companies = companies;
  },

  [types.SET_MENU_ITEM_ID](state, menu) {
    state.menuItemId = menu.id;
  },

  [types.SET_USER_HAS_VALID_ROLE](state, value) {
    state.userHasValidRole = value;
  },
};
